import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//constantes
const dataInicial = {
    data: {},
    fc_30: {
        nombrerazonsocial: '',
        numerocliente: '',
        fechasolicitud: fechaHoy,
        fechapropuestaactividad: fechaHoy,
        responsabletraslado: '',
        otrainstalacion: false,
        paracomprayventa: false,
        superviciondocumental: false,
        supervicionsitio: true,

        propiasalida: false,
        noregistradasalida: false,
        tipoinstalacionsalida: '',
        razonsocialsolicitante: '',
        numeroclientesolicitante: '',
        responsableinstalacionessolicit: '',
        correoelectronicosolicitante: '',
        telefonosolicitante: '',
        domiciliosolicitante: '',

        propiarecepcion: false,
        otroclienterecepcion: false,
        noregistradarecepcion: false,
        tipoinstalacionrecepcion: '',
        razonsocialrecepcion: '',
        numeroclienterecepcion: '',
        responsableinstalacionesrecepci: '',
        correoelectronicorecepcion: '',
        telefonorecepcion: '',
        domiciliorecepcion: '',
        observaciones: '',
        salida_propductor_maquilador:false,
        recepcion_productor_maquilador:false
    },
    loading: false,
    productos: {},
    fc_30Map: {},
    productosMap: [],
    paginaActiva: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    cliente: [],
    instalacionesCliente: [],
    dataLogin: [],
    dataDocumentacion: {},
    files: [],
    filesProductos: [],
    instalacionesRelacionadasRecepcion: [],
    instalacionesRelacionadasSolicitante: [],
    filesMap: [],
    filesProductosMap: [],

}


//types
const OBTENER_FC_30_MAP_EXITO = 'OBTENER_FC_30_MAP_EXITO'
const AGREGAR_FC_30_EXITO = 'AGREGAR_FC_30_EXITO'
const AGREGAR_PRODUCTO_FC_30_EXITO = 'AGREGAR_FC_30_PRODUCTO_EXITO'
const AGREGAR_FC_30_BORRADOR_EXITO = 'AGREGAR_FC_30_BORRADOR_EXITO'
const ACTUALIZAR_FC_30_ESTATUS_EXITO = 'ACTUALIZAR_FC_30_ESTATUS_EXITO'
const ELIMINAR_FC_30_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_30_SOLICITUD_EXITO_BD'
const ELIMINAR_FC_30_ANEXOPRODUCTO_EXITO_BD = 'ELIMINAR_FC_30_ANEXOPRODUCTO_EXITO_BD'

const OBTENER_CLIENTE_POR_LOGIN_EXITO_30 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO_30'
const OBTENER_FC_30_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_30_CONTADOR_FECHA_FOLIO_EXITO'
const OBTENER_FC_30_DETALLE_EXITO = 'OBTENER_FC_30_DETALLE_EXITO'
const AGREGAR_ARCHIVO_FC_30_EXITO = 'AGREGAR_ARCHIVO_FC_30_EXITO'
const ACTUALIZAR_ARCHIVO_FC_30_EXITO = 'ACTUALIZAR_ARCHIVO_FC_30_EXITO'
const OBTENER_INSTALACIONES_CLIENTE30_EXITO = 'OBTENER_INSTALACIONES_CLIENTE30_EXITO'
const AGREGAR_FC_30_FECHA_EXITO = 'AGREGAR_FC_30_FECHA_EXITO'
const ACTUALIZAR_FC_30_BORRADOR_EXITO = 'ACTUALIZAR_FC_30_BORRADOR_EXITO'
const ENVIAR_FC_30_BORRADOR_EXITO = 'ENVIAR_FC_30_BORRADOR_EXITO'
const ACTUALIZAR_FC_30_SOLICITUD = 'ACTUALIZAR_FC_30_SOLICITUD'
const OBTENER_INSTALACIONES_CLIENTE30_SOLICITANTE_EXITO= 'OBTENER_INSTALACIONES_CLIENTE30_SOLICITANTE_EXITO'

export const ObtenerClientePorLogin30 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO_30,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`

            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            let idcartera = res.data.data.idcartera

            const fullUrlInstalaciones = host + `InformacionValida/obtenerTodosAnexosCliente/${idcliente}`
            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            //const fullUrlRelaciones = host + `AtencionAClientes/obtenerRelacionesPorIdCliente/${idcliente}`

            const resinstalaciones = await axios.get(fullUrlInstalaciones)
            //const resRelaciones = await axios.get(fullUrlRelaciones)
            let datos = []
            //let marcas = []
            let instalaciones = []
            instalaciones.push(resinstalaciones.data.data)

            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)
            datos.push(res.data.data, instalaciones, datosLogin,
                //resRelaciones.data.data
            )
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_30_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarFC_30Accion = createAsyncThunk(
    AGREGAR_FC_30_EXITO,
    async (data) => {
        try {
            const productos = data.productos
            const fullUrl = host + `FC_30/agregarNuevoFC_30TrasladoProducto`
            const urlAnexoProductos = host + `FC_30/agregarFormatoFC30_AnexoProducto`

            const res = await axios.post(fullUrl, { data: data.solicitud })
            let idfc30_notificaciontrasladodepr = res.data.data.idfc30_notificaciontrasladodepr

            for (let i in productos) {
                const { id, ...anexo } = productos[i]
                anexo.idfc30_notificaciontrasladodepr = idfc30_notificaciontrasladodepr
                delete anexo?.fc_30archivoproducto 
                const result = await axios.post(urlAnexoProductos, { data: anexo })
            }

            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_30SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_30_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_30/obtenerFormatoFC30_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)

            let instalacionesRelacionadasCliente = []
            if (res.data.data.numeroclienterecepcion) {
                const fullUrl1 = host + `InformacionValida/obtenerClientePorNumSocio/${res.data.data.numeroclienterecepcion}`
                const res1 = await axios.get(fullUrl1)
                let idcliente = res1.data.data.idcliente
                const fullUrlInstalaciones = host + `InformacionValida/obtenerInstalacionesRelacionadas/${idcliente}`
                const resinstalaciones = await axios.get(fullUrlInstalaciones)
                instalacionesRelacionadasCliente = resinstalaciones.data.data
            }
            let instalacionesBusquedaClienteSolicitud = []
            if (res?.data?.data?.numeroclientesolicitante) {
                const fullUrl1 = host + `InformacionValida/obtenerClientePorNumSocio/${res.data.data.numeroclientesolicitante}`
                const res1 = await axios.get(fullUrl1)
                let idcliente = res1.data.data.idcliente
                const fullUrlInstalaciones = host + `InformacionValida/obtenerInstalacionesRelacionadas/${idcliente}`
                const resinstalaciones = await axios.get(fullUrlInstalaciones)
                instalacionesBusquedaClienteSolicitud = resinstalaciones.data.data
            }

            const fc_30_anexoproducto = []
            const documentosProductos = []
            for (let i in res.data.data.fc_30_anexoproducto) {
                res.data.data.fc_30_anexoproducto[i]['id'] = uuidv4()
                for (const j in res.data.data.fc_30_anexoproducto[i].fc_30archivoproducto) {
                    const { ...anexo } = res.data.data.fc_30_anexoproducto[i].fc_30archivoproducto[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_30archivoproducto,
                        idAnexoFK: res.data.data.fc_30_anexoproducto[i].idfc30_anexoproducto,
                        estatus: true,
                    }

                    documentosProductos.push(data)
                }
            }
            fc_30_anexoproducto.push({ data: res.data.data.fc_30_anexoproducto })

            const documentosFC_30 = []
            //FILES
            for (const i in res.data.data.fc_30archivos) {
                const { ...anexo } = res.data.data.fc_30archivos[i]
                const data = {
                    id: anexo.nameid,
                    file: { name: await getNameFile(anexo.ruta) },
                    idAnexo: anexo.idfc_30archivos,
                    idAnexoFK: res.data.data.idfc30_notificaciontrasladodepr,
                    estatus: true,
                }

                documentosFC_30.push(data)
            }
            if (res.data.data.fechapropuestaactividad) {
                let fecha = res.data.data.fechapropuestaactividad
                res.data.data.fechapropuestaactividad = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }

            return { data: res.data.data, fc_30_anexoproducto, documentosFC_30, documentosProductos, instalacionesRelacionadasCliente,instalacionesBusquedaClienteSolicitud }
        } catch (error) {
            console.log(error);
        }
    }
)
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}
export const agregarFileFC_30 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_30_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFileFC_30 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_30_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const ObtenerInstalacionesClienteRecepcion = createAsyncThunk(
    OBTENER_INSTALACIONES_CLIENTE30_EXITO,
    async (numerosocio) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorNumSocio/${numerosocio}`
            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            const fullUrlActividad = host + `InformacionValida/obtenerActividadClientePorCliente/${idcliente}`
            const resActividad = await axios.get(fullUrlActividad)
            let filtro = resActividad.data.data.filter(anexo => anexo?.idtipoactividad == 3 || anexo?.idtipoactividad == 4 || anexo?.idtipoactividad == 5 || anexo?.idtipoactividad == 6)
            let resinstalaciones = []
            if (filtro.length>0) {
                const fullUrlInstalaciones = host + `InformacionValida/obtenerInstalacionesRelacionadas/${idcliente}`
                resinstalaciones = await axios.get(fullUrlInstalaciones)
            }
            return resinstalaciones?.data?.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const ObtenerInstalacionesClienteSolicitante = createAsyncThunk(
    OBTENER_INSTALACIONES_CLIENTE30_SOLICITANTE_EXITO,
    async (numerosocio) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorNumSocio/${numerosocio}`
            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            const fullUrlActividad = host + `InformacionValida/obtenerActividadClientePorCliente/${idcliente}`
            const resActividad = await axios.get(fullUrlActividad)
            let filtro = resActividad.data.data.filter(anexo => anexo?.idtipoactividad == 3 || anexo?.idtipoactividad == 4 || anexo?.idtipoactividad == 5 || anexo?.idtipoactividad == 6)
            let resinstalaciones = []
            if (filtro.length>0) {
                const fullUrlInstalaciones = host + `InformacionValida/obtenerInstalacionesRelacionadas/${idcliente}`
                resinstalaciones = await axios.get(fullUrlInstalaciones)
            }
            return resinstalaciones?.data?.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_30Fecha = createAsyncThunk(
    AGREGAR_FC_30_FECHA_EXITO,
    async (data) => {
        try {
            const actualizarFC_30 = host + `FC_30/actualizarFC_30TrasladoProducto`
            const res = await axios.put(actualizarFC_30, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_30Estatus = createAsyncThunk(
    ACTUALIZAR_FC_30_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_30Map = createAsyncThunk(
    OBTENER_FC_30_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_30_NotificacionTraslado/${solicitudId}`
            const res = await axios.get(fullUrl)
            let mapFiles = []
            let productosMap = []
            let filesProductosMap = []
            let observacionesGeneral = 0
            let observacionesProductos = 0
            let observacionesFilesProductos = 0

            const Map = await obtenerProductosMap(solicitudId)
            productosMap.push(Map.anexoProductoMap)
            //mapFiles.push(Map.filesGeneralMap)
            filesProductosMap.push(Map.filesProductosMap)

            for (const i in res.data.data) {
                if (res.data.data[i] === true) observacionesGeneral++
            }
            for (const i in productosMap[0]) {
                if (productosMap?.[0]?.[i]?.productocheck === true) observacionesProductos++
            }
            for (const i in filesProductosMap[0]) {
                if (filesProductosMap?.[0]?.[i]?.estatuscheck === true) observacionesFilesProductos++
            }
            let observacionesStatus = { observacionesGeneral: observacionesGeneral, observacionesProductos: observacionesProductos, observacionesFilesProductos: observacionesFilesProductos }
            const solicitudMap = {
                data: res.data.data,
                //mapFiles: mapFiles,
                productosMap: productosMap,
                filesProductosMap: filesProductosMap,
                observacionesStatus: observacionesStatus
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerProductosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_30/obtenerFormatoFC30_ConDetalle/${idSolicitud}`
        const obtenerProductoMap = host + `MapSolicitud/obtenerMapFC_30_AnexoProducto/`
        const obtenerArchivoProductoMap = host + `MapSolicitud/obtenerMapFC_30_ArchivosProductos/`
        const res = await axios.get(fullUrl)
        const filesProductos = res.data.data.fc_30_anexoproducto

        const filesProductosMap = []
        for (const producto of filesProductos) {
            for (const archivo of producto.fc_30archivoproducto) {
                const resfiles = await axios.get(obtenerArchivoProductoMap + archivo.idfc_30archivoproducto)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_30archivoproducto
                    filesProductosMap.push(resfiles.data.data)
                }
            }
        }
        // const filesProductos = res.data.data
        let anexoProductoMap = []
        for (const anexo of res.data.data.fc_30_anexoproducto) {
            const resMap = await axios.get(obtenerProductoMap + anexo.idfc30_anexoproducto)
            anexoProductoMap.push(resMap.data.data)

        }
        let Map = { anexoProductoMap: anexoProductoMap, filesProductosMap: filesProductosMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}

export const agregarFC_30SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_30_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = data.productos
            const agregarFC_30 = host + 'FC_30/agregarNuevoFC_30TrasladoProducto'
            const urlAnexoProductos = host + 'FC_30/agregarFormatoFC30_AnexoProducto'

            const res = await axios.post(agregarFC_30, solicitud)
            let idfc30_notificaciontrasladodepr = res.data.data.idfc30_notificaciontrasladodepr
            for (let i in productos) {
                const { id, ...anexo } = productos[i]
                anexo.idfc30_notificaciontrasladodepr = idfc30_notificaciontrasladodepr
                const result = await axios.post(urlAnexoProductos, { data: anexo })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_30SolicitudBorrador = createAsyncThunk(
    ACTUALIZAR_FC_30_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = data.productos
            let archivos = null

            if (data.archivos) {
                archivos = data.archivos
            }
            const actualizarFC_30 = host + `FC_30/actualizarFC_30TrasladoProducto`

            const urlAgregarAnexoProductos = host + 'FC_30/agregarFormatoFC30_AnexoProducto'
            const urlActualizarAnexoProductos = host + 'FC_30/actualizarFormatoFC30_AnexoProducto'
            const res = await axios.put(actualizarFC_30, solicitud)

            let idfc30_notificaciontrasladodepr = res.data.data.idfc30_notificaciontrasladodepr
            for (let i in productos) {
                if (productos[i].idfc30_anexoproducto) {
                    const { fc_30archivoproducto, id, ...anexo } = productos[i]
                    const resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })
                } else {
                    const { id, ...anexoProducto } = productos[i]
                    anexoProducto.idfc30_notificaciontrasladodepr = idfc30_notificaciontrasladodepr
                    await axios.post(urlAgregarAnexoProductos, { data: anexoProducto })
                }
            }
            return data
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_30AnexoProductoBD = createAsyncThunk(
    ELIMINAR_FC_30_ANEXOPRODUCTO_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_30/eliminarFormatoFC30_AnexoProducto/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const enviarBorradorFC_30 = createAsyncThunk(
    ENVIAR_FC_30_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = data.productos

            const actualizarFC_30 = host + `FC_30/actualizarFC_30TrasladoProducto`
            const urlAgregarAnexoProductos = host + 'FC_30/agregarFormatoFC30_AnexoProducto'
            const urlActualizarAnexoProductos = host + 'FC_30/actualizarFormatoFC30_AnexoProducto'

            const res = await axios.put(actualizarFC_30, solicitud)
            let idfc30_notificaciontrasladodepr = res.data.data.idfc30_notificaciontrasladodepr

            /*Acciones para anexo productos*/
            for (let i in productos) {
                const { id, fc_30archivoproducto, ...anexo } = productos[i]
                let resAnexoId = null
                if (productos[i].idfc30_anexoproducto) {
                    const result = await axios.put(urlActualizarAnexoProductos, { data: anexo })
                    resAnexoId = result.data.data.idfc30_anexoproducto
                } else {
                    anexo.idfc30_notificaciontrasladodepr = idfc30_notificaciontrasladodepr
                    const result = await axios.post(urlAgregarAnexoProductos, { data: anexo })
                    resAnexoId = result.data.data.idfc30_anexoproducto
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_30Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_30_SOLICITUD,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = { data: data.productos }
            const actualizarFC_30 = host + `FC_30/actualizarFC_30TrasladoProducto`
            const urlActualizarAnexoProductos = host + 'FC_30/actualizarFormatoFC30_AnexoProducto'

            const res = await axios.put(actualizarFC_30, solicitud)

            for (let i in productos.data) {
                if (productos.data[i].idfc30_anexoproducto) {
                    const { fc_30archivoproducto, id, ...anexo } = productos.data[i]
                    const resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })
                }
            }

            return res
        } catch (error) {
            console.log(error)
        }
    }
)













export const eliminarFC_30SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_30_SOLICITUD_EXITO_BD,
    async (id) => {
        try {
            const fullUrlSolicitud = host + `FC_30/eliminarFormatoFC30/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return { id }
        } catch (error) {
            console.log(error);
        }
    }
)

export const fc30Slice = createSlice({
    name: 'fc30Slice',
    initialState: dataInicial,
    reducers: {




        guardarCambiosFC_30SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        guardarCambiosFC_30SolicitudNueva(state, { payload }) {
            state.fc_30 = payload
        },
        actualizarModoBorradorFC_30(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarFC_30PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        actualizarModoCorrecionFC_30(state, { payload }) {
            state.modoCorreccion = payload
        },
        resetDataFC_30(state, { payload }) {
            return dataInicial
        },
        agregarFC_30AnexoProducto(state, { payload }) {
            state.productos = payload
        },
        agregarFC_30Producto(state, { payload }) {
            state.productos.data.push(payload)
        },
        editarFC_30AnexoProducto(state, { payload }) {
            const input = state.productos.data.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        actualizarResponsableFC_30(state, { payload }) {
            state.instalacionesCliente = payload
        },

    },
    extraReducers: {
        [ObtenerClientePorLogin30.fulfilled]: (state, { payload }) => {
            state.cliente = payload[0]
            //state.marcasCliente = payload[1]
            state.instalacionesCliente = payload[1][0]
            state.dataLogin = payload[2][0][0]
            //state.relacionesCliente = payload[4]
        },
        [obtenerFC_30SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            state.fc_30 = payload.data
            state.dataDocumentacion = payload.data
            state.productos = { data: payload.data.fc_30_anexoproducto }
            state.files = { data: payload.documentosFC_30 }
            state.filesProductos = { data: payload.documentosProductos }
            state.instalacionesRelacionadasRecepcion = payload.instalacionesRelacionadasCliente
            state.instalacionesRelacionadasSolicitante = payload.instalacionesBusquedaClienteSolicitud
            
        },
        [ObtenerInstalacionesClienteRecepcion.fulfilled]: (state, { payload }) => {
            state.instalacionesRelacionadasRecepcion = payload
        },
        [ObtenerInstalacionesClienteSolicitante.fulfilled]: (state, { payload }) => {
            state.instalacionesRelacionadasSolicitante = payload
        },
        [obtenerFC_30Map.fulfilled]: (state, { payload }) => {
            state.fc_30Map = payload.data
            state.productosMap = payload.productosMap[0]
            //state.filesMap = payload.mapFiles[0]
            state.filesProductosMap = payload.filesProductosMap[0]
            state.observacionesStatus = payload.observacionesStatus
        },







        [agregarFC_30SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [agregarFC_30Accion.fulfilled]: (state, { payload }) => {
        },

        [actualizarFC_30Estatus.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_30SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_30SolicitudBD.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_30AnexoProductoBD.fulfilled]: (state, { payload }) => {
            const filtro = { data: state.productos.data.filter(anexo => anexo.idfc30_anexoproducto !== payload) }
            state.productos = filtro
        },

    },
})

//actions
export const {


    actualizarModoBorradorFC_30,
    actualizarModoCorrecionFC_30,
    guardarCambiosFC_30SolicitudBorrador,
    guardarCambiosFC_30SolicitudNueva,
    resetDataFC_30,
    actualizarFC_30PaginaActiva,
    agregarFC_30AnexoProducto,
    agregarFC_30Producto,
    editarFC_30AnexoProducto,
    actualizarResponsableFC_30
} = fc30Slice.actions

export const FC30ReducerBeneficiario = fc30Slice.reducer